module.exports = __webpack_public_path__ + "icon_question_circle_blue.08060.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_question_circle_blue.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_question_circle_blue.svg
// module chunks = main